module.exports = __webpack_public_path__ + "img/WebApplication.80681fca.jpg";